export default __webpack_public_path__ + "static/media/EFC8D984-692F-476D-8CD5-EB13967424E8.703ca966.jpeg";